var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPanelTextLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.279,
    height: 52,
    viewBox: "0 0 92.279 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_490",
    "data-name": "Group 490",
    transform: "translate(-9413.281 -2592)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_1",
    "data-name": "Exclusion 1",
    d: "M41,24H1a1,1,0,0,1-1-1V1A1,1,0,0,1,1,0H41a1,1,0,0,1,1,1V23A1,1,0,0,1,41,24ZM16.5,6.375a.5.5,0,0,0-.5.5V18.124a.5.5,0,0,0,.5.5.492.492,0,0,0,.253-.07L26.27,12.93a.5.5,0,0,0,0-.86L16.753,6.446A.492.492,0,0,0,16.5,6.375Z",
    transform: "translate(9463.561 2592)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_477",
    "data-name": "Rectangle 477",
    width: 36.279,
    height: 3,
    rx: 1.5,
    transform: "translate(9413.281 2592)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_479",
    "data-name": "Rectangle 479",
    width: 36.279,
    height: 3,
    rx: 1.5,
    transform: "translate(9413.281 2604)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_481",
    "data-name": "Rectangle 481",
    width: 36.279,
    height: 3,
    rx: 1.5,
    transform: "translate(9413.281 2617)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_483",
    "data-name": "Rectangle 483",
    width: 36.279,
    height: 3,
    rx: 1.5,
    transform: "translate(9413.281 2629)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_485",
    "data-name": "Rectangle 485",
    width: 36.279,
    height: 3,
    rx: 1.5,
    transform: "translate(9413.281 2641)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelTextLeft);
export default __webpack_public_path__ + "static/media/panel-text-left.7dd2c597f98bab3da2c7b27e0b90c3ba.svg";
export { ForwardRef as ReactComponent };